export class OptionItem {
    value: any;
    text: string;
    isSelected = false;

    constructor(value: any, text: string, isSelected?: boolean) {
      this.value = value;
      this.text = text;
      this.isSelected = isSelected ?? false;
    }
}

export class SummaryOptionItem {
    value: any;
    text: string;
    isSelected = false;
    isDisabled = false;
    color:string;

    constructor(value: any, text: string, isSelected?: boolean, isDisabled?: boolean,color?:string) {
      this.value = value;
      this.text = text;
      this.isSelected = isSelected ?? false;
      this.isDisabled = isDisabled ?? false;
      this.color = color;
    }
}
export class OptionItemDataType {
    value: any;
    text: string;
    dataType: string;

    constructor(value: any, text: string, dataType: string) {
      this.value = value;
      this.text = text;
      this.dataType = dataType;
    }
}
